var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(this.$route.meta.layout || 'div',{tag:"component"},[_c('router-view')],1),_c('api-notification'),_c('portal-target',{attrs:{"name":"modals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }